import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupAssignmentComponent } from '@markant-platform/dashboard/feature-dashboard-group-assignment';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { HighlightDialogOffset, HighlightDialogPosition, HighlightDialogSize } from '../../model/highlight-dialog';

@Component({
  selector: 'markant-platform-guided-tour-highlight-dialog',
  standalone: true,
  imports: [CommonModule, GroupAssignmentComponent, MarkantElementsModule, TranslocoModule],
  templateUrl: './guided-tour-highlight-dialog.component.html',
  styleUrl: './guided-tour-highlight-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidedTourHighlightDialogComponent implements OnChanges {
  @Input({ required: true }) targetId!: string;
  @Input({ required: true }) currentStep!: number;
  @Input({ required: true }) textBaseKey?: string;
  @Input() dialogPosition?: HighlightDialogPosition;
  @Input() viewSize?: HighlightDialogSize;
  @Input() stepsWithPreviousButton?: number[];

  @Output() previous: EventEmitter<void> = new EventEmitter<void>();
  @Output() next: EventEmitter<void> = new EventEmitter<void>();

  dialogStyle = '';
  viewStyle = '';
  showPreviousButton = false;

  ngOnChanges(): void {
    this.showPreviousButton = !!this.stepsWithPreviousButton && this.stepsWithPreviousButton.includes(this.currentStep);
    this.dialogStyle = this.generateDialogPositionAsString(this.dialogPosition);
    this.viewStyle = this.getSizeAsString(this.viewSize);
  }

  emitPrevious(): void {
    this.previous.emit();
  }

  emitNext(): void {
    this.next.emit();
  }

  private generateDialogPositionAsString(position?: HighlightDialogPosition): string {
    if (!position) {
      return '';
    }

    const dialogPositionString = Object.entries(position).reduce((styleString, [key, value]) => {
      if (key === 'position' && value) {
        styleString += `position: ${value}; `;
      } else if ((key === 'vertical' || key === 'horizontal') && value) {
        const offset = value as HighlightDialogOffset;
        styleString += `${offset.from}: ${offset.amount}; `;
      }
      return styleString;
    }, '');

    return dialogPositionString.trim();
  }

  private getSizeAsString(size?: HighlightDialogSize): string {
    return size ? `width: ${size.width}; min-width: ${size.width}; height: ${size.height};` : '';
  }
}
